<template>
  <div class="psuccess">
    <div class="message">
      <h2>支付成功</h2>
      <div class="sus">
        <div class="fl">
            <i class="el-icon-success"></i>
        </div>
        <div class="fr">
            <h3>订单支付成功!</h3>
            <p><span>重要提示:</span>我们不会以订单异常，系统升级为由，要求您点击任何连接进行退款</p>
        </div>
      </div>
      <p class="btn">
        <button @click="toMyOrder">查看我的订单</button>
      </p>
    </div>
    <hr>
  </div>
</template>
<script>
export default {
  name: 'paysuccess',
  props: ['type'],
  data () {
    return {
    }
  },
  methods: {
    toMyOrder() {
      if (this.type === '0') {
        this.$router.push('/home/dataOrders')
      } else {
        this.$router.push('/home/orders')
      }
    }
  }
}
</script>

<style lang="less">
.newpopover[x-placement^="bottom"] {
  margin-top: 12px;
}
.newpopover[x-placement^="bottom"] .popper__arrow::after {
  top: 1px;
  margin-left: -6px;
  border-top-width: 0;
  border-bottom-color: rgb(25, 27, 46);
}
.newpopover[x-placement^="bottom"] .popper__arrow {
  top: -6px;
  left: 50%;
  margin-right: 3px;
  border-top-width: 0;
  border-bottom-color: rgb(25, 27, 46);
}
.newpopover {
  position: absolute;
  background: rgb(25, 27, 46);
  min-width: 130px;
  border-radius: 2px;
  padding: 0px;
  z-index: 2000;
  color: #ffffff;
  line-height: 1.4;
  text-align: justify;
  border: 0px;
  font-size: 14px;
  margin-left: 20px;
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  word-break: break-all;
}
.popdiv {
  cursor: pointer;
  width: 110px;
  height: 20px;
  padding: 10px;
}
.popdiv:hover {
  background-color: rgb(28, 203, 150);
  width: 110px;
  height: 20px;
  padding: 10px;
}
.popper__arrow {
  left: 85px !important;
}
.rightgo {
  margin-right: 10px;
}
.psuccess{
  width: 1100px;
  margin: 80px auto;
  min-height: 482px;
  .message{
    border: 3px solid #f5f7fa;
    border-radius: 5px;
    color: #818180;
    h2{
      padding-left: 25px;
      height: 45px;
      line-height: 45px;
      background-color:#f5f7fa;
    }
    .sus{
      padding-top: 50px;
      color: #333;
      overflow: hidden;
      .fl{
        float: left;
        width: 220px;
        text-align: right;
        font-size: 80px;
        color: #1ccb96;
      }
      .fr{
        padding-top: 24px;
        line-height: 2.5em;
        font-size: 14px;
        color: #b4b4b4;
        h3{
          font-size: 16px;
          color:#737373;
          font-weight: 600;
        }
        span{
          color: #1ccb96;
        }
        margin-left: 250px
      }
    }
    .btn{
      text-align: center;
      padding: 40px 0px;
      button{
        font-size: 12px;
        background-color: #1ccb96;
        color: #fff;
        padding: 10px 22px;
        border-radius: 18px;
        border: none;
        cursor: pointer;
      }
      button:hover{
        opacity: 0.8;
      }
    }
  }
  hr{
    background-color: #f5f7fa;
    height: 2px;
    border: 0;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/order/paysuccess.vue